import React, { useEffect, useState } from "react";
import { Box, Button, ButtonBase, Dialog, Divider, List, Stack, Typography } from "@mui/material";
// import close_bg from '../../../assets/images/close_bg.svg';
// import close_s from '../../../assets/images/close_s.svg';
// import close_w from '../../../assets/images/close_w.svg';
// import back_r from '../../../assets/images/back_r.svg';
// import notepad from '../../../assets/images/notepad.svg';
// import dining_bg from '../../../assets/images/dining_bg.png';
// import card from '../../../assets/images/card.svg';
import { useInfoStore } from "../../../store/userInfo";
import { useTranslation } from "react-i18next";
import { useWindowDimensions } from "../../../App";
import { isBrowser } from 'react-device-detect';
import { useKioskStore } from "../../../store/kiosk";
import { NavigateFunction, useNavigate } from "react-router-dom";
import { createKioskOrder, getTaxInfo, kioskReset } from "../../../services/order.service";
import { useOrderStore } from "../../../store/order";
import { useAnalytics } from "../../../analytics/AnalyticsContext";
import { useMenuStore } from "../../../store/menuState";
import { logger } from "../../../utils/logger";


const orderType = ['', 'Dine-In', "To-Go"]

enum RetryMode {
  NONE = 'none',
  TIMEOUT = 'timeout',
  DECLINED = 'declined',
  DECLINED_FINISH = 'declined_finish'
}

const MyOrder = () => {
  const { userInfo, currentLng, tableInfo } = useInfoStore();
  const { height } = useWindowDimensions();
  const { openMyOrder, kioskOrderList, setOpenMyOrder, setOpenCallName  } = useKioskStore();
  const { resetOrderCart } = useOrderStore();
  const { isNativeFlag } = useMenuStore();
  const navigate: NavigateFunction = useNavigate();
  const storeId = userInfo?.storeId;
  const { orientation } = useWindowDimensions();
  const landMode = orientation === "landscape";
  const {t} =  useTranslation(`${storeId}`)
  const [tax, setTax] = useState(0)
  const [paying, setPaying] = useState(false)
  const [payInfo, setPayinfo] = useState<any>({})
  const [complete, setComplete] = useState(false)
  const [retryMode, setRetryMode] = useState(RetryMode.NONE)
  const [retryData, setRetryData] = useState(null)
  const [retryCount, setRetryCount] = useState(0);
  const [timer, setTimer] = useState(60);

  const maxRetries = 2; // 최대 2번의 추가 재시도 (총 3번)
  const { recordOrderEvent } = useAnalytics();

  // 30초 타이머 효과
  useEffect(() => {
    let interval: NodeJS.Timeout;
    
    if ((complete || retryMode !== RetryMode.NONE) && timer > 0) {
      interval = setInterval(() => {
        setTimer((prevTimer) => {
          if (prevTimer <= 1) {
            logger.log('timer end')
            handleNewOrder();
            return 0;
          }
          logger.log('timer', prevTimer, retryMode)
          return prevTimer - 1;
        });
      }, 1000);
    }

    return () => {
      if (interval) {
        clearInterval(interval);
      }
    };
  }, [complete, retryMode, timer]);

  // complete나 retryMode가 변경될 때 타이머 리셋
  // useEffect(() => {
  //   if (complete || retryMode === RetryMode.DECLINED_FINISH) {
  //     setTimer(30);
  //   } else if (retryMode === RetryMode.TIMEOUT || retryMode === RetryMode.DECLINED) {
  //     setTimer(60);
  //   }
  // }, [complete, retryMode]);

  // useEffect(() => {
  //   const eventSourceInitDict = {
  //     headers: {
  //       'Content-Type': 'application/json',
  //       'Access-Control-Allow-Origin': '*',
  //       ...authHeader()
  //     },
  //     heartbeatTimeout: 110000
  //   };
  //   const es = new EventSourcePolyfill(
  //     `${process.env.REACT_APP_URI}sse/users?storeId=${storeId}`,
  //     eventSourceInitDict
  //   );

  //   es.onopen = () => logger.log(">>> Connection opened!");
  //   es.onerror = (e) => logger.log("ERROR!", e);
  //   es.onmessage = (e) => {
  //     logger.log("es2 >>>", e.data);
  //     switch (e.data.type) {
  //       case 'menu':
  //         if (!isBrowser && window.ReactNativeWebView !== undefined) {
  //           window.ReactNativeWebView.postMessage(JSON.stringify({ 'type': 'reload' }));
  //         }
  //         return;
  //       case 'PAYMENT_ISSUE':
  //         // alert(JSON.stringify(e.data.payload));
  //         return;
  //       default:
  //         alert(JSON.stringify(e.data));
  //         return;
  //     }
  //   };

  //   return () => es.close();
  // }, [storeId]);

  useEffect(() => {
    if(!kioskOrderList) return
    async function getTex() {
      const tableName = tableInfo.tableName
      await getTaxInfo(storeId, tableName, kioskOrderList).then(
        (res) => {
          logger.log(res.data)
          if(res.data > 0)
            setTax(res.data)
        },
        (error) => {
          logger.log(error)
        }
      )
    }
    getTex();
  },[kioskOrderList])
  
  const onClickBack = () => {
    // if (!isBrowser) {
    //   if (window.ReactNativeWebView !== undefined) {
    //     window.ReactNativeWebView.postMessage(JSON.stringify({'type': 'play'}));
    //   } else if(window.Android !== undefined) {
    //     window.Android.postMessage(JSON.stringify({'type':'play'}));
    //   }
    // }
    // setCompleteList({}as JSON)
    setOpenMyOrder(false)
    setOpenCallName(true)
    navigate('/callname')
  } 

  const  hideDialog = () => {
    // if (!isBrowser) {
    //   if (window.ReactNativeWebView !== undefined) {
    //     window.ReactNativeWebView.postMessage(JSON.stringify({'type': 'play'}));
    //   } else if(window.Android !== undefined) {
    //     window.Android.postMessage(JSON.stringify({'type':'play'}));
    //   }
    // }
    // setCompleteList({}as JSON)
    setOpenMyOrder(false)
    navigate('/main')
  }

  const handleKioskOrder = async () => {
    const tableName = tableInfo.tableName
    logger.log(tableName)
    setOpenMyOrder(false)
    setPaying(true)
    setRetryCount(0); // 초기 시도 시 카운트 리셋
    await createKioskOrder(storeId, tableName, kioskOrderList, tax, false, false).then(
      (res) => {
        logger.log(res, res.data)
        if(res.status === 200 || res.status === 201) {
          logger.log(res.data)
          setOpenMyOrder(false)
          setPayinfo(res.data)
          setPaying(false)
          setComplete(true)
          setRetryMode(RetryMode.NONE)
          // Analytics: 주문 성공
          if(!isNativeFlag) {
          recordOrderEvent('kiosk', true, 
            kioskOrderList.orderItems.length, 
            res.data.totalAmount, 
            { 
              storeId: userInfo?.storeId || 'unknown',
              tableName: userInfo?.tableName || 'unknown',
              paymentMethod: res.data.method || 'unknown',
              orderNo: res.data.dailyOrderNo || 'unknown'
              }
            );
          } else {
            if (window.Android !== undefined)
              window.Android.postMessage(JSON.stringify({ type: 'attr', data: {function: 'kiosk', orderItems: kioskOrderList.orderItems.length, totalAmount: res.data.totalAmount, storeId: userInfo?.storeId || 'unknown', tableName: userInfo?.tableName || 'unknown', paymentMethod: res.data.method || 'unknown', orderNo: res.data.dailyOrderNo || 'unknown'} }));
          }
        } else if(res.response.status === 402 || res.response.status === 504){
          logger.log('error')
          setPaying(false)
          setOpenMyOrder(false)
          setRetryData(res.response.data)
          if(res.response.status === 402) {
            setRetryMode(RetryMode.DECLINED)
          } else if(res.response.status === 504) {
            setRetryMode(RetryMode.TIMEOUT)
          }
          setRetryCount(retryCount + 1);
        }  else {
          logger.log('error')
          setPaying(false)
          setOpenMyOrder(true)
        }
      },
      (error) => {
        logger.log(error)
        setPaying(false)
        // Analytics: 주문 실패
        if(!isNativeFlag) {
          recordOrderEvent('kiosk_retry', false, 
            kioskOrderList.orderItems.length, 
            0, 
            { 
              storeId: userInfo?.storeId || 'unknown',
              tableName: userInfo?.tableName || 'unknown',
              paymentMethod: 'unknown',
              retryCount: retryCount,
              error: error instanceof Error ? error.message : 'Unknown error'
            }
          );
        } else {
          if (window.Android !== undefined)
            window.Android.postMessage(JSON.stringify({ type: 'attr', data: {function: 'kiosk_retry', orderItems: kioskOrderList.orderItems.length, totalAmount: 0, storeId: userInfo?.storeId || 'unknown', tableName: userInfo?.tableName || 'unknown', paymentMethod: 'unknown', retryCount: retryCount + 1, error: error instanceof Error ? error.message : 'Unknown error'} }));
        }
      }
    )
  }
  
  const handleNewOrder = () => {
    setComplete(false)
    resetOrderCart()
    navigate('/main')
  }

  const onClickTryAgain = () => {
    setTimer(0); // 타이머 취소
    retryKioskOrder(retryData!)
  }

  const retryKioskOrder = async (retryData: { data: any; }) => {
    const tableName = tableInfo.tableName
    const payload = retryData.data
    const isFinalTry = retryCount === maxRetries
    setPaying(true)
 
    try {
      const res = await createKioskOrder(storeId, tableName, kioskOrderList, tax, true, isFinalTry, payload);
      logger.log(res, res.data);
      if(res.status !==  undefined && (res.status === 200 || res.status === 201)) {
        logger.log(res.data);
        setOpenMyOrder(false);
        setPayinfo(res.data);
        setPaying(false);
        setComplete(true);
        setRetryMode(RetryMode.NONE)
        setRetryCount(0);
        // Analytics: 주문 성공
        if(!isNativeFlag) {
          recordOrderEvent('kiosk', true, 
            kioskOrderList.orderItems.length, 
            res.data.totalAmount, 
            { 
              storeId: userInfo?.storeId || 'unknown',
              tableName: userInfo?.tableName || 'unknown',
              paymentMethod: res.data.method || 'unknown',
              orderNo: res.data.dailyOrderNo || 'unknown'
            }
          );
        } else {
          if (window.Android !== undefined)
            window.Android.postMessage(JSON.stringify({ type: 'attr', data: {function: 'kiosk', orderItems: kioskOrderList.orderItems.length, totalAmount: res.data.totalAmount, storeId: userInfo?.storeId || 'unknown', tableName: userInfo?.tableName || 'unknown', paymentMethod: res.data.method || 'unknown', orderNo: res.data.dailyOrderNo || 'unknown'} }));
        }
      } else if(res.response.status === 402 || res.response.status === 504){
        logger.log('error')
        setPaying(false)
        setOpenMyOrder(false)
        if(res.response.status === 402) {
          setTimer(60);
          setRetryMode(RetryMode.DECLINED)

        } else if(res.response.status === 504) {
          setTimer(60);
          setRetryMode(RetryMode.TIMEOUT)
        }
        setRetryCount(retryCount + 1);
        if(retryCount >= maxRetries) {
          setRetryData(res.response.data);
          if(retryMode === RetryMode.DECLINED) {
            setTimer(30);
            setRetryMode(RetryMode.DECLINED_FINISH);
          } else {
            // setOpenMyOrder(false);
            // setPayinfo(res.data);
            // setPaying(false);
            // setComplete(true);
            // setRetryMode(RetryMode.NONE)
            // setRetryCount(0);
            setPaying(false);
            setRetryMode(RetryMode.NONE)
            onClickNo();
          }
        } 
      } else {
        logger.log('error')
        setRetryMode(RetryMode.NONE)
        setPaying(false)
        setOpenMyOrder(true)
      }
    } catch (error) {
      logger.log(error);
      if(retryCount <= maxRetries) {
        setRetryCount(retryCount + 1);
        setOpenMyOrder(false);
        setRetryMode(RetryMode.TIMEOUT);
        setPaying(false);
        // Analytics: 주문 실패
        if(!isNativeFlag) {
          recordOrderEvent('kiosk_retry', false, 
            kioskOrderList.orderItems.length, 
            0, 
            { 
              storeId: userInfo?.storeId || 'unknown',
              tableName: userInfo?.tableName || 'unknown',
              paymentMethod: 'unknown',
              retryCount: retryCount,
              error: error instanceof Error ? error.message : 'Unknown error'
            }
          );
        } else {
          if (window.Android !== undefined)
            window.Android.postMessage(JSON.stringify({ type: 'attr', data: {function: 'kiosk_retry', orderItems: kioskOrderList.orderItems.length, totalAmount: 0, storeId: userInfo?.storeId || 'unknown', tableName: userInfo?.tableName || 'unknown', paymentMethod: 'unknown', retryCount: retryCount + 1, error: error instanceof Error ? error.message : 'Unknown error'} }));
        }
      } else {
        setPaying(false);
        setRetryMode(RetryMode.NONE)
        onClickNo();
      }
    }
  }

  const onClickNo = async () => {
    const tableId = tableInfo.id
    await kioskReset(tableId).then(
      () => {
        logger.log('kiosk reset')
        setRetryMode(RetryMode.NONE)
        handleNewOrder()
      }
    )
  }

  const checkingImage = () => {
    switch(retryMode) {
      case RetryMode.TIMEOUT:
        return `${process.env.PUBLIC_URL}/assets/images/timeout.svg`;
      case RetryMode.DECLINED:
        return `${process.env.PUBLIC_URL}/assets/images/decline.svg`;
      case RetryMode.DECLINED_FINISH:
        return `${process.env.PUBLIC_URL}/assets/images/decline2.svg`;
      default:
        return `${process.env.PUBLIC_URL}/assets/images/decline.svg`;
    }
  }

  // Dialog가 열릴 때 body와 html 스크롤 막기
  useEffect(() => {
    if (openMyOrder || paying || retryMode !== RetryMode.NONE || complete) {
      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
      document.documentElement.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
      document.documentElement.style.overflow = '';
    };
  }, [openMyOrder, paying, retryMode, complete]);

  if(Object.keys(kioskOrderList).length === 0 ) return <></>
  if(paying) {
    return(
      <Dialog open={paying} fullScreen>
          <section style={{  
              backgroundImage: `url("${process.env.PUBLIC_URL+'/assets/images/dining_bg.png'}")`,
              backgroundPosition: 'center',
              backgroundSize: 'cover',
              backgroundRepeat: 'no-repeat',
              height: '100vh',
              width: '100vw',
              padding: '180px 240px 310px 230px'
          }}>
            <Box sx={{display: 'flex', flexDirection: 'row', justifyContent: 'center'}}>
              <img src={process.env.PUBLIC_URL+'/assets/images/tap2pay.svg'} width={'150px'} height={'150px'} alt="card" />
            </Box>
            <Stack sx={{ flexDirection: 'column', justifyContent: 'center', alignItems: 'center', marginTop: '20px'}}>
              <Typography sx={{color: '#000', fontSize: '50px', fontStyle: 'normal', fontWeight: '700', minHeight: '75px'}}>PLEASE FOLLOW</Typography>
              <Typography sx={{color: '#000', fontSize: '50px', fontStyle: 'normal', fontWeight: '700', minHeight: '75px'}}>INSTRUCTION ON DEVICE.</Typography>
            </Stack>
            <Box sx={{display: 'flex', flexDirection: 'row', justifyContent: 'center', mt: '57px'}}>
              <img src={process.env.PUBLIC_URL+'/assets/images/down.svg'} width={'100px'} height={'100px'} alt="card" />
            </Box>
          </section>
      </Dialog>
    ) 
  }else if(retryMode !== RetryMode.NONE) {
    return (
      <Dialog open={true} fullScreen>
          <section style={{  
              backgroundImage: `url(${process.env.PUBLIC_URL+'/assets/images/dining_bg.png'})`,
              backgroundPosition: 'center',
              backgroundSize: 'cover',
              backgroundRepeat: 'no-repeat',
        height: '100vh',
        width: '100vw',
        padding: '92px 240px 169px 230px'
          }}>
            <Stack sx={{ flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}>
              <img src={checkingImage()} width={'150px'} height={'150px'} alt="line"/>
              <Typography sx={{color: '#000', fontSize: '50px', fontStyle: 'normal', fontWeight: '700', mt: '20px'}}>
                {retryMode === RetryMode.TIMEOUT ? 'Payment timed out.' : 'Payment declined.'}
              </Typography>
              <Typography sx={{color: '#000', fontSize: retryMode === RetryMode.DECLINED_FINISH ? '30px' : '50px', fontStyle: 'normal', fontWeight: '700'}}>
                {retryMode === RetryMode.DECLINED_FINISH ? 'Please try another payment method or contact the store.' : 'Try again?'}
              </Typography>
              <Box sx={{display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', gap: '20px', mt: '40px'}}>
                {retryMode !== RetryMode.DECLINED_FINISH ? (
                  <Stack sx={{gap : '20px'}}>
                    <ButtonBase sx={{width: '422px', height: '69px', padding: '4px 33px', borderRadius: '60px', background: '#F72E13'}} onClick={() => onClickTryAgain()}>
                      <Box sx={{display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', gap: '10px'}}>
                        <Typography sx={{color: '#fff', textAlign: 'center', fontSize: '26px', fontWeight: '700', lineHeight: '150%'}}>Retry Payment</Typography>
                        <Typography sx={{color: '#fff', fontSize: '16px', fontWeight: '500', mt: '8px'}}>({timer}s)</Typography>
                      </Box>
                    </ButtonBase>
                    <ButtonBase sx={{width: '422px', height: '69px', padding: '4px 33px', borderRadius: '60px', background: '#CACACA'}} onClick={() => onClickNo()}>
                      <Typography sx={{color: '#fff', textAlign: 'center', fontSize: '26px', fontWeight: '700', lineHeight: '150%'}}>No</Typography>
                    </ButtonBase>
                  </Stack>
                ): <Stack sx={{gap : '2.0rem'}}>
                <ButtonBase sx={{width: '42.2rem', height: '6.9rem', padding: '0.4rem 3.3rem', borderRadius: '6.0rem', background: '#F72E13'}} onClick={() => handleNewOrder()}>
                  <Box sx={{display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', gap: '1.0rem'}}>
                    <Typography sx={{color: '#fff', fontSize: '2.6rem', fontWeight: '700'}}>START NEW ORDER </Typography>
                    <Typography sx={{color: '#fff', fontSize: '1.6rem', fontWeight: '500', mt: '0.8rem'}}>({timer}s)</Typography>
                  </Box>
                </ButtonBase>
              </Stack>}
              </Box>
            </Stack>
          </section>
      </Dialog>
    )
  }
  if(complete) return(
    <Dialog open={complete} fullScreen PaperProps={{ style: { overflow: 'hidden' } }}>
        <section style={{  
            backgroundImage: `url("${process.env.PUBLIC_URL+'/assets/images/dining_bg.png'}")`,
            backgroundPosition: 'center',
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            height: '100vh',
            width: '100vw',
            padding: '9.2rem 14.0rem 16.9rem 14.0rem'
        }}>
          <Stack sx={{ flexDirection: 'column', justifyContent: 'center', alignItems: 'center', marginTop: '4.2rem'}}>
            <Typography sx={{color: '#000', fontSize: '5.0rem', fontStyle: 'normal', fontWeight: '700', minHeight: '7.5rem'}}>THANK YOU, {kioskOrderList.customerName}!</Typography>
            <Typography sx={{color: '#000', fontSize: '3.0rem', fontStyle: 'normal', fontWeight: '500', minHeight: '4.5rem'}}>We'll call your name when your order is ready.</Typography>
            <Stack sx={{width: '61.7rem', height: '29.5rem', padding: '2.0rem 4.0rem', alignItems: 'center', gap: '1.0rem', borderRadius: '1.5rem', background: '#fff', boxShadow: '0px 0px 20px 0px rgba(0, 0, 0, 0.10)', 
              marginTop: '3.0rem'}}>
              <Typography sx={{color: '#000', fontSize: '3.0rem', fontStyle: 'normal', fontWeight: '700', height: '4.5rem'}}>ORDER NUMBER</Typography>
              <Typography sx={{color: '#F72E13', fontSize: '6.0rem', fontStyle: 'normal', fontWeight: '700', height: '21.0rem'}}>#{payInfo.dailyOrderNo}</Typography>
              <Button sx={{width: '61.7rem', height: '11.2rem', padding: '1.0rem 4.9rem 1.0rem 4.7rem', justifyContent: 'center', alignItems: 'center', backgroundColor: '#000', borderRadius: '6.0rem',
                marginTop: '3.0rem'}} onClick={() => handleNewOrder()}>
                <Box sx={{display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', gap: '1.0rem'}}>
                  <Typography sx={{color: '#fff', fontSize: '3.6rem', fontWeight: '600'}}>START NEW ORDER </Typography>
                  <Typography sx={{color: '#fff', fontSize: '2.6rem', fontWeight: '500', mt: '0.8rem'}}>({timer}s)</Typography>
                </Box>
              </Button>
            </Stack>
          </Stack>
        </section>
    </Dialog>
  )
    return (
      <Dialog open={openMyOrder} fullScreen sx={{ height: '100vh',}} PaperProps={{ style: { overflow: 'hidden' } }}>
        <div className="touch-area" style={{position: 'absolute', left: '4.8rem', top: '3.0rem'}} onClick={()=> onClickBack()}>
          <Box>
            <img src={process.env.PUBLIC_URL+'/assets/images/close_s.svg'} width={'56px'} height={'56px'} alt="back" />
            <img src={process.env.PUBLIC_URL+'/assets/images/back_r.svg'} width={'30px'} height={'30px'} alt="back" style={{position: 'absolute', left: '1.3rem', top: '1.3rem'}}/>
          </Box>
        </div>
        <div className="touch-area" style={{position: 'absolute',  right: '52px', top: '30px'}} onClick={()=> hideDialog()}>
          <Box>
            <img src={process.env.PUBLIC_URL+'/assets/images/close_bg.svg'} width={'56px'} height={'56px'} alt="back" />
            <img src={process.env.PUBLIC_URL+'/assets/images/close_w.svg'} width={'24px'} height={'24px'} alt="back" style={{position: 'absolute', left: '1.6rem', top: '1.6rem'}}/>
          </Box>
        </div>
        <Box sx={{display: 'flex', flexDirection: 'row', justifyContent: 'center', mt: '3.2rem'}}>
          <Typography sx={{fontSize: '4.0rem', fontWeight: '700', lineHeight: '150%', color: '#000'}}>MY ORDER</Typography>
        </Box>
        <Box sx={{m: '5.6rem 4.9rem 3.6rem 4.8rem', display: 'flex', flexDirection: landMode?'row':'column', gap: '3.1rem', justifyContent: 'center', flex:1 }}>
          <List style={{ overflow: 'overlay', overflowX: 'hidden', height: landMode ? `${height -28.5}rem` : '60%', gap: '2.0rem' }}>
            {kioskOrderList.orderItems.map((item: any, index: number) => {
              return(
                <Box key={`cart-${index}`} sx={{ justifyContent: 'center', mx: '2.5rem',}}>

                  <Box sx={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', gap: '8.0rem'}}>
                    <Typography sx={{width: '49.8rem', fontSize: '2.2rem', fontWeight: '600', fontStyle: 'normal', letterSpacing: '-0.22px'}}>{t(`itemNames.${item.itemId}.${currentLng}`)}</Typography>
                    <Typography sx={{width: '8.0rem', fontSize: '2.4rem', fontWeight: '700', fontStyle: 'normal', letterSpacing: '-0.22px', textAlign: 'end'}}>x{item.quantity}</Typography>
                    <Typography sx={{width: '12.0rem', fontSize: '2.4rem', fontWeight: '700', fontStyle: 'normal', letterSpacing: '-0.22px', textAlign: 'end'}}>${(item.itemPrice/100).toFixed(2)}</Typography>
                  </Box>
                  { item.orderModifiers && item.orderModifiers.length !== 0 ?
                    <Stack>
                      {item.orderModifiers.map((modifier: any) => (
                        <Box key={`modifier-${modifier.id}`}sx={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}}>
                          <Typography sx={{fontSize: '1.8rem', fontWeight: '400', fontStyle: 'normal', color: '#F72E13', textAlign: 'left'}}>{t(`optionNames.${modifier.modifierId}.${currentLng}`)}</Typography>
                          <Typography sx={{fontSize: '1.8rem', fontWeight: '500', fontStyle: 'normal', color: '#F72E13', textAlign: 'right'}}>${(modifier.modifierPrice/100).toFixed(2)}</Typography>
                        </Box>
                      ))}
                    </Stack>
                  :<></>}
                  {item.specialRequest !== undefined ?
                  <Box sx={{display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center', mt: '1.6rem'}}>
                    <img src={process.env.PUBLIC_URL+'/assets/images/notepad.svg'} width={'2.7rem'} height={'2.7rem'} alt='notepad' />
                    <Typography sx={{width: '63.6rem', display: 'inline-block', whiteSpace: 'nowrap', overflow: 'auto', overflowY: 'hidden', fontSize: '1.8rem', fontWeight: '400',
                      letterSpacing: '-0.18px', height: '4.0rem', padding: '0.4rem 0.5rem'
                    }}>
                      {item.specialRequest}
                    </Typography>
                  </Box>
                  : <></>}
                  <Typography sx={{fontSize: '2.0rem', fontWeight: '600', letterSpacing:'-0.2px', textAlign: 'right', mt: '0.5rem'}}>${(item.subtotalAmount/100).toFixed(2)}</Typography>

                  <Divider sx={{ alignSelf: 'center', borderBlockColor: '#d8d8d8', my: '1.0rem'}}/>
                </Box>
              )
            })}
          </List>
          <Stack sx={{padding: '2.5rem 0rem', alignItems: 'center', gap: '1.0rem', borderRadius: '1.5rem', background: '#f8f8f8', height: landMode ? `${height- 16.0}rem` : '40%', width: landMode ?'36.9rem' : '100%'}}>
            <Box sx={{alignSelf: 'flex-start', width: '100%', paddingLeft: '2.0rem'}}>
              <Typography sx={{fontSize: '3.0rem', fontWeight: '700', textAlign: 'left'}}>Hello,</Typography>
              <Typography sx={{fontSize: '3.0rem', fontWeight: '700', textAlign: 'left'}}>{kioskOrderList.customerName}</Typography>
              <Box sx={{width: '15.8rem', height: '4.1rem', padding: '0.4rem 2.6rem', background: '#000', borderRadius: '6.0rem', marginTop: '1.0rem'}}>
                <Typography sx={{color: '#fff', textAlign: 'center', fontSize: '2.2rem', fontWeight: '600'}}>{orderType[kioskOrderList.orderType || 0]}</Typography>
              </Box>
            </Box>
            <Stack sx={{ justifyContent: 'center', alignItems: 'center', width: 'auto', minWidth: '32.0rem', maxWidth: 'fit-content', position: 'absolute', bottom: '4.0rem', }}>
              <Box sx={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', width: '100%'}}>
                <Typography sx={{fontSize: '2.2rem', fontWeight: '500'}}>Subtotal</Typography>
                <Typography sx={{fontSize: '2.2rem', fontWeight: '500', textAlign: 'right'}}>${(kioskOrderList.totalAmount/100).toFixed(2)}</Typography>
              </Box>
              <Box sx={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', width: '100%', mt: '0.4rem'}}>
                <Typography sx={{fontSize: '2.2rem', fontWeight: '500'}}>Tax&Fees</Typography>
                <Typography sx={{fontSize: '2.2rem', fontWeight: '500', textAlign: 'right'}}>${(tax/100).toFixed(2)}</Typography>
              </Box>
              <Divider sx={{ alignSelf: 'center', height: '0.1rem', borderBlockColor: '#000', my: '0.8rem', width: '100%'}}/>
              <Box sx={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', width: '100%'}}>
                <Typography sx={{fontSize: '2.6rem', fontWeight: '500'}}>Total</Typography>
                <Typography sx={{fontSize: '2.6rem', fontWeight: '600', textAlign: 'right'}}>${((kioskOrderList.totalAmount+tax)/100).toFixed(2)}</Typography>
              </Box>
              <ButtonBase disabled={!tax} sx={{padding: '1.5rem 0rem', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '1.0rem', borderRadius: '6.0rem', background: '#F72E13', mt: '2.9rem', width: '100%'}}
                onClick={() =>  handleKioskOrder()}>
                <Box sx={{display: 'flex', flexDirection: 'row', justifyContent: 'center', gap: '1.4rem', whiteSpace: 'nowrap', width: '100%'}}>
                  <Typography sx={{color: '#fff', textAlign: 'left', fontSize: '2.6rem', fontWeight: '700', width: 'auto', minWidth: 'fit-content'}}>Check Out</Typography>
                  <Typography sx={{color: '#fff', textAlign: 'right', fontSize: '2.6rem', fontWeight: '700', width: 'auto', minWidth: 'fit-content'}}>${((kioskOrderList.totalAmount+tax)/100).toFixed(2)}</Typography>
                </Box>
              </ButtonBase>
            </Stack>
          </Stack>
        </Box>


      </Dialog>
    ) 
  };

  
  export default MyOrder;


